import React, { useEffect, useState } from 'react'
import './TagCloud.scss'

const TagCloud = ({ items, cloudObject, query, onClick, showCounts = true }) => {
	const [cloud, setCloud] = useState([])
	useEffect(() => {
		if(cloudObject){
			const newCloud = getTagCloud(cloudObject)
			setCloud(newCloud)
		}
		return () => {
			setCloud([])
		}
	}, [items])
console.log(`cloudObject`, cloudObject)
	if (!items) return <div></div>;
	const myquery = { ...query }
	if (!myquery.tags) myquery.tags = []

	return (
		<div className="TagCloud">
			{myquery.tags.map(srow => {
				const active = 'active';
				return (
					<div key={srow} className={`tag ${active}`} onClick={(e) => onClick(srow)}>
						<div className="tag-name">{srow}</div>
					</div>
				)
			})}
			{cloud
				.filter(row => myquery.tags.indexOf(row.tag) < 0)
				.map(row => {
					const active = (myquery?.tags?.indexOf(row.tag) > -1) ? 'active' : ''
					return (
						<div key={row.tag} className={`tag ${active}`} onClick={(e) => onClick(row.tag)}>
							<div className="tag-name">{row.tag}</div>
							{showCounts && <div className="tag-cnt">{row.cnt}</div>}
						</div>
					)
				})}

		</div>
	)
}

function getTagCloud(cloudObject) {
	const out = Object.keys(cloudObject).map(key => ({ tag: key, cnt: cloudObject[key] }))
	return out.sort((A, B) => B.cnt - A.cnt);
}

function getTagCloudOld(items) {
	if (!items) return []
	const cloud = {}
	items.forEach(item => {
		const aTags = item.tags ? item.tags.split(',').map(u => u.trim()) : []
		aTags.forEach(tag => {
			if (!cloud[tag]) cloud[tag] = 0;
			cloud[tag]++;
		})
	})
	const out = Object.keys(cloud).map(key => ({ tag: key, cnt: cloud[key] }))
	return out.sort((A, B) => B.cnt - A.cnt);
}
export default TagCloud
